import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'transportStatus',
})
export class TransportStatusPipe implements PipeTransform {
  transform(value: string): string {
    return `transport.status.${value}`;
  }
}
